<script setup lang="ts">
import { Input } from '@/components/ui/input'
import { Select, SelectContent, SelectItem, SelectSeparator, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useForm } from '@inertiajs/vue3'
import { useDebounceFn } from '@vueuse/core'
import { Search } from 'lucide-vue-next'
import { watch } from 'vue'

const props = defineProps<{
    statuses: string[]
    categories: string[]
    workshops: Array<{ id: number; label: string }>
    query?: string
    status?: string
    category?: string
    workshop?: string
}>()

const form = useForm({
    query: props.query || '',
    status: props.status || null,
    category: props.category || null,
    workshop: props.workshop || null,
})

watch(
    () => form.data(),
    () => {
        filterForm()
    },
)

const filterForm = useDebounceFn(() => {
    form.get('/coupons', {})
}, 300)
</script>

<template>
    <div class="mb-8 grid gap-6 md:grid-cols-4">
        <div class="relative w-full items-center">
            <Input id="search" type="text" :placeholder="$t('Search')" class="pl-10" v-model="form.query" />
            <span class="absolute inset-y-0 start-0 flex items-center justify-center px-2">
                <Search class="text-muted-foreground size-5" />
            </span>
        </div>

        <Select class="w-full" v-model="form.category">
            <SelectTrigger class="w-full">
                <SelectValue :placeholder="$t('Type of coupon')" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem :value="null">
                    {{ $t('Type of coupon') }}
                </SelectItem>
                <SelectSeparator />
                <SelectItem v-for="category in categories" :value="category" :key="category">
                    {{ $t(category) }}
                </SelectItem>
            </SelectContent>
        </Select>

        <Select class="w-full" v-model="form.status">
            <SelectTrigger class="w-full">
                <SelectValue :placeholder="$t('Status')" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem :value="null">
                    {{ $t('Coupon status') }}
                </SelectItem>
                <SelectSeparator />
                <SelectItem v-for="status in statuses" :value="status" :key="status">
                    {{ $t(status) }}
                </SelectItem>
            </SelectContent>
        </Select>

        <Select class="w-full" v-model="form.workshop">
            <SelectTrigger class="w-full">
                <SelectValue :placeholder="$t('Workshop')" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem :value="null">
                    {{ $t('Workshop') }}
                </SelectItem>
                <SelectSeparator />
                <SelectItem v-for="workshop in workshops" :value="String(workshop.id)" :key="workshop.id">
                    {{ workshop.label }}
                </SelectItem>
            </SelectContent>
        </Select>
    </div>
</template>
